module.exports = __webpack_public_path__ + "img/sathapana_mobile.87390036.jpg";